module.exports = __webpack_public_path__ + "static/media/Auditorias.ea3f76be.png";